import '../scss/main.scss';
import { initNav } from './nav.js';
import { initCarousels } from './carousel.js';
import { initFilters } from './filter.js';

// Vanilla JS only (no jQuery). Components self-init on DOM ready.
const ready = (fn) =>
  document.readyState !== 'loading'
    ? fn()
    : document.addEventListener('DOMContentLoaded', fn);

ready(() => {
  initNav();
  initCarousels();
  initFilters();
});
